import React from 'react';
import { Route } from 'react-router';

// Components
import PageList from 'components/common/PageList';
import ListAccounts from 'components/head-office/ListAccounts';
import AccountInvoices from 'components/head-office/AccountInvoices';

//-----------------------------------------------------------------

class Network extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            page: 'accounts'
        };

        this.pages = [
            { id: 'accounts', label: 'Accounts' },
            //{ id: 'account-invoices', label: 'Invoices' }
        ];
    }

    //----------------------------------------------------------------------

    render() {
        const { page } = this.props;

        return (<>

            <section className="control-panel">

                <PageList
                    pages={this.pages}
                    page={page}
                    getURL={(id) => `/network/${id}`}
                />

            </section>

            <Route path="/network/accounts" render={() => <ListAccounts {...this.props} />} />
            {/*<Route path="/network/account-invoices" render={() => <AccountInvoices {...this.props} />} />*/}

        </>);
    }

}

export default Network;